module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/13-05349143d1f15ae7293f6ee59b343c6d.jpg";